import { render, staticRenderFns } from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=template&id=5b7250c9&scoped=true"
import script from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePaiDomiciliareEditModalComponent.vue?vue&type=style&index=0&id=5b7250c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7250c9",
  null
  
)

export default component.exports